var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSpeaker = function SvgSpeaker(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M9.814 2.097a.56.56 0 0 1 .242.459v8.888a.556.556 0 0 1-.757.518l-4.903-1.906H1.444A.556.556 0 0 1 .89 9.5v-5c0-.307.249-.556.555-.556h2.952l4.903-1.906a.56.56 0 0 1 .515.059m-.87 8.535L5.056 9.12V4.88l3.888-1.512zM2 5.056v3.888h1.944V5.056z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11.445 4.5a.556.556 0 1 0 0 1.111H12A.556.556 0 1 0 12 4.5zM10.611 7.278c0-.307.249-.556.556-.556h1.389a.556.556 0 0 1 0 1.111h-1.39a.556.556 0 0 1-.555-.555M11.445 8.944a.556.556 0 1 0 0 1.112H12a.556.556 0 1 0 0-1.112z"
  })));
};
export default SvgSpeaker;